import {Pipe, PipeTransform} from '@angular/core';
import {orderBy} from 'lodash';

/**
 * *ngFor="let c of oneDimArray | sortBy:'asc'"
 * *ngFor="let c of arrayOfObjects | sortBy:'asc':'propertyName'"
 */

@Pipe({name: 'sortBy'})
export class SortByPipe implements PipeTransform {

  transform(value: any[], order: 'asc'|'desc' = 'asc', column: string = ''): any[] {
    // no array
    if (!value || !order) {
      return value;
    }

    // array with only one item
    if (value.length <= 1) {
      return value;
    }

    // sort 1d array
    if (!column || column === '') {
      if (order === 'asc') {
        return value.sort();
      } else {
        return value.sort().reverse();
      }
    }

    return orderBy(value, [column], [order]);
  }
}
